import React, { useState, useRef } from "react";
import "./envelope-block.scss";
import { gsap } from "gsap";
import predictions from "../../assets/data.json";
import EnvelopeImg from "../../assets/images/envelope.png";
import EnvelopeTopImg from "../../assets/images/envelope-top.png";
import EnvelopeBackImg from "../../assets/images/envelope-back.png";
import DecorImg from "../../assets/images/decor.png";
import SealIcon from "../../assets/icons/seal.svg"

const EnvelopeBlock = () => {
  const [isFirstOpen, setIsFirstOpen] = useState(true);
  const [canAnimation, setCanAnimation] = useState(true);
  const [randomIndex, setRandomIndex] = useState(
    Math.floor(Math.random() * predictions.length)
  );

  const envelopeRef = useRef(null);
  const envelopeImgTopRef = useRef(null);
  const envelopeTextRef = useRef(null);
  const envelopeDecorRef = useRef(null);
  const envelopeButtonRef = useRef(null);
  const envelopeTitleRef = useRef(null);
  const envelopeSealRef = useRef(null);

  const handlerClickEnvelope = () => {
    if (!canAnimation) return;
    setCanAnimation(false);

    const tl = gsap.timeline();

    if (isFirstOpen) {
      tl.to(envelopeSealRef.current, {
        opacity: 0,
        duration: 0.5
      })
      tl.to('.hero', {
        opacity: 0,
        duration: 1
      }, '<')
      tl.to(envelopeImgTopRef.current, {
        rotateX: 180,
        duration: 1,
      });
      tl.to(
        envelopeRef.current,
        {
          // paddingTop: 130,
          duration: 1,
        },
        "<"
      );
      tl.to(
        ".footer",
        {
          // paddingTop: 47,
          duration: 1,
        },
        "<"
      );
      tl.set(
        envelopeImgTopRef.current,
        {
          zIndex: 0,
        },
        "-=0.7"
      );
      tl.to(envelopeTextRef.current, {
        y: "-47%",
        height: "auto",
        duration: 0.6,
      });
      tl.to(
        envelopeDecorRef.current,
        {
          y: 0,
          scale: 1,
          duration: 1,
        },
        "-=0.5"
      );
      tl.to(envelopeButtonRef.current, {
        opacity: 1,
        duration: 0.3,
        onComplete: () => {
          setCanAnimation(true);
        },
      });
      tl.to(envelopeTitleRef.current, {
        opacity: 0,
        duration: 0.3,
      });
      setIsFirstOpen(false);
    } else {
      tl.to(envelopeButtonRef.current, {
        opacity: 0,
        duration: 1,
      });
      tl.to(
        envelopeDecorRef.current,
        {
          y: "50%",
          scale: 0,
          duration: 1,
        },
        "<"
      );
      tl.to(
        envelopeTextRef.current,
        {
          y: 0,
          height: "100%",
          duration: 1,
          delay: 0.5
        },
        "<"
      );
      tl.to(envelopeImgTopRef.current, {
        rotateX: 0,
        duration: 1,
      });
      tl.set(
        envelopeImgTopRef.current,
        {
          zIndex: 4,
        },
        "-=0.7"
      );
      tl.to(envelopeImgTopRef.current, {
        rotateX: 180,
        duration: 1,
        delay: 1,
        onStart: () => {
          setRandomIndex(Math.floor(Math.random() * predictions.length));
        },
      });
      tl.set(
        envelopeImgTopRef.current,
        {
          zIndex: 0,
        },
        "-=0.7"
      );
      tl.to(envelopeTextRef.current, {
        y: "-47%",
        height: "auto",
        duration: 0.6,
      });
      tl.to(
        envelopeDecorRef.current,
        {
          y: 0,
          scale: 1,
          duration: 1,
        },
        "-=0.5"
      );
      tl.to(envelopeButtonRef.current, {
        opacity: 1,
        duration: 0.3,
        onComplete: () => {
          setCanAnimation(true);
        },
      });
    }
  };

  const currentText = predictions[randomIndex].text;

  return (
    <section className="envelope" ref={envelopeRef}>
      <h3 className="envelope__title" ref={envelopeTitleRef}>
        Нажмите на конверт
      </h3>

      <div className="envelope__content">
      <img ref={envelopeSealRef} className="envelope__seal" src={SealIcon} alt="Печать" />
        <img
          src={EnvelopeTopImg}
          alt="envelope-top"
          className="envelope__img-top"
          ref={envelopeImgTopRef}
        />
        <img
          src={EnvelopeBackImg}
          alt="envelope-top"
          className="envelope__img-back"
        />
        <img
          src={EnvelopeImg}
          alt="envelope"
          className="envelope__img"
          onClick={handlerClickEnvelope}
        />
        <img
          src={DecorImg}
          alt="decor"
          className="envelope__decor"
          ref={envelopeDecorRef}
        />
        <div
          className="envelope__text"
          dangerouslySetInnerHTML={{ __html: currentText }}
          ref={envelopeTextRef}
        />
      </div>

      <div className="envelope__buttons" ref={envelopeButtonRef}>
        <button className="envelope__button" onClick={handlerClickEnvelope}>
          Хочу ещё предсказание
        </button>
      </div>
    </section>
  );
};

export default EnvelopeBlock;
